import { render, staticRenderFns } from "./data-analysis.vue?vue&type=template&id=200a39d6&scoped=true"
import script from "./data-analysis.vue?vue&type=script&lang=js"
export * from "./data-analysis.vue?vue&type=script&lang=js"
import style0 from "./data-analysis.vue?vue&type=style&index=0&id=200a39d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200a39d6",
  null
  
)

export default component.exports